import { useEffect, useState } from "react";

// Lib
import parse from "html-react-parser";

// Utils
import { handleOverrideClassName, handleJsBridgeForAppVersion } from "../../utils/CommonFunctions";
import { versionItem, versionBuild } from "../../ComponentInterface";
import usePWADetection from "../../hooks/usePWADetection";

interface Props {
  item: versionItem;
}

const Version = ({ item }: Props) => {
  const [appVersionObj, setAppVersionObj] = useState<versionBuild>({ version: "", build: "" });
  const { isPWA } = usePWADetection();
  const [copyrightYear, setCopyrightYear] = useState("");
  //  Call the Js Bridge on Component Load
  useEffect(() => {
    const fetchAppVersion = async () => {
      if (isPWA) {
        setAppVersionObj({ version: "Web Version", build: "" });
        return;
      }

      const versionObj = await handleJsBridgeForAppVersion();

      if (versionObj && Object.keys(versionObj).length !== 0) {
        setAppVersionObj(versionObj as versionBuild);
      }
    };

    fetchAppVersion();
  }, [isPWA]);

  useEffect(() => {
    setCopyrightYear(new Date().getFullYear().toString());
  }, []);

  return (
    <div className={`app-version-component ${handleOverrideClassName(item.classname)}`}>
      <div className="content-section">
        {/* App Version Text */}

        {item.title && appVersionObj?.version && (
          <div className="app-version-row">
            <span className={`header-text ${handleOverrideClassName(item.headerTextClassname)}`}>
              {" "}
              {parse(item.title)}
            </span>
            {appVersionObj?.version && (
              <span className="app-version">{`${appVersionObj?.version}`}</span>
            )}

            {appVersionObj?.build && (
              <span className="build-version">{`(${appVersionObj?.build})`}</span>
            )}
          </div>
        )}

        {/* Description */}

        {item.copyright && (
          <p className={`bodyText ${handleOverrideClassName(item.bodyTextClassname)}`}>
            {"\u00A9"}
            {copyrightYear} {parse(item.copyright)}
          </p>
        )}
      </div>

      {item.image && (
        <div
          className={`img-card ${handleOverrideClassName(item.imgClassname)}`}
          style={{ backgroundImage: item.image.path && `url(${item.image.path})` }}
        />
      )}
    </div>
  );
};

export default Version;
